import type SubjectTypeView from '@UI/Store/SubjectTypes/Views/SubjectTypeView';

/** Immutable View of the dossier types reachable by the current user in one account. */
class SubjectTypesListView {
	readonly accountId: number;
	readonly types: readonly SubjectTypeView[];

	constructor(accountId: number, types: readonly SubjectTypeView[]) {
		this.accountId = accountId;
		this.types = types;

		Object.freeze(this);
	}

	get isEmpty(): boolean {
		return this.types.length === 0;
	}

	findByKey(key: string): SubjectTypeView | null {
		return this.types.find((type) => type.key === key) ?? null;
	}

	findById(id: number): SubjectTypeView | null {
		return this.types.find((type) => type.id === id) ?? null;
	}
}

export default SubjectTypesListView;
